export default "__VITE_ASSET__MYuKUUV$__"